import {
  generateJoiValidation,
  isSiteCreatedFields,
  withLeadRoutingConditionalFields,
} from '@/shared/validations/generateJoiValidation';
import { MakanifySites } from '@/modules/makanifySites/makanifySites.model';
import Joi from 'joi';

export const createMakanifySites = (isUpsert: boolean) => {
  const siteValidation = generateJoiValidation(MakanifySites.schema, isUpsert);
  const siteValidationWithType =
    withLeadRoutingConditionalFields(siteValidation);
  return { body: siteValidationWithType };
};

export const isSiteCreated = () => ({
  query: isSiteCreatedFields(),
});

export const createMakanifyLead = () => {
  const lead = {
    body: Joi.object({
      name: Joi.string().trim().required(),
      phone: Joi.string().required(),
      email: Joi.string().email().required(),
      message: Joi.string().required(),
      listingId: Joi.string().required(),
    }),
  };
  return lead;
};